<ng-container  *ngFor="let error of group.get(field.name).errors | keyvalue">
    <ng-container *ngIf="errorMessages.get(error.key); else defaultValidationMesssage">
        <span *ngIf="group.get(field.name).touched" class="d-block text-danger">{{errorMessages.get(error.key)}}</span>
    </ng-container>

    <ng-template #defaultValidationMesssage>
        <app-reactive-validation-message *ngIf="group.get(field.name).touched" [reactiveFormControl]="group.get(field.name)" [errorName]="error.key" [activateTouched]="true"></app-reactive-validation-message>
    </ng-template>
</ng-container>
